// extracted by mini-css-extract-plugin
module.exports = {"note":"Note_note__G0V89","noteContainer":"Note_noteContainer__24obQ","notes":"Note_notes__1uP_U"};